module.exports = __webpack_public_path__ + "static/media/ma.60fbc221.svg";